module.exports = __webpack_public_path__ + "img/8.334c4f31.jpg";